// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Breadcrumbs_wrapper_2OW6C","crumb":"Breadcrumbs_crumb_3gNl8","arrow_icon":"Breadcrumbs_arrow_icon_2QMYz","last":"Breadcrumbs_last_3IfXx"};